"use strict";

/* Horizontally overflowing track: touch scrolls natively, a mouse drags, arrows page. The element wraps the scrollport (.drag-scroller__track) so the arrows do not scroll with it. */
/* Guarded: two sections can each emit a script tag for this file, and a second define() throws. */
if (!customElements.get("drag-scroller")) {
customElements.define(
  "drag-scroller",
  class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector(".drag-scroller__track");
      if (!this.track) {
        return;
      }

      this.pressed = false;
      this.dragging = false;

      this.track.addEventListener("scroll", this.onScroll.bind(this), {
        passive: true,
      });
      this.onScroll();

      // Overflow changes without a scroll when the viewport or content resizes.
      if (!this.resizeObserver && "ResizeObserver" in window) {
        this.resizeObserver = new ResizeObserver(this.onScroll.bind(this));
        this.resizeObserver.observe(this.track);
      }

      // Coarse pointers scroll natively; dragging and arrows would only get in a thumb's way.
      if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
        return;
      }

      this.buildArrows();

      this.track.addEventListener("pointerdown", this.onDown.bind(this));
      this.track.addEventListener("pointermove", this.onMove.bind(this));
      this.track.addEventListener("pointerup", this.onUp.bind(this));
      this.track.addEventListener("pointercancel", this.onUp.bind(this));

      // Otherwise the browser's native image drag hijacks the gesture before any of this runs.
      this.track.addEventListener("dragstart", (event) =>
        event.preventDefault()
      );

      this.classList.add("drag-scroller--draggable");
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    }

    buildArrows() {
      var self = this;

      /* .control / .control-left carry the look, hover and back-arrow flip; not .swipeable-control--pill, which is for inside a picture. */
      /* Labels come from Liquid (general.previous / general.next) so they follow the storefront language. */
      [
        ["prev", this.dataset.labelPrevious, "control-left"],
        ["next", this.dataset.labelNext, "control"],
      ].forEach(function (pair) {
        var button = document.createElement("button");
        button.type = "button";
        button.className =
          pair[2] + " drag-scroller__arrow drag-scroller__arrow--" + pair[0];
        button.setAttribute("aria-label", pair[1]);
        button.innerHTML =
          '<svg class="btn-icon" width="13" height="8" viewBox="0 0 13 8" aria-hidden="true">' +
          '<use href="#icon-arrow-no-space"></use></svg>';
        button.addEventListener("click", function () {
          self.page(pair[0] === "next" ? 1 : -1);
        });
        self.appendChild(button);
      });
    }

    /* Most of a screenful: one tile of overlap shows the track moved rather than jumped. */
    page(direction) {
      this.track.scrollBy({
        left: direction * this.track.clientWidth * 0.8,
        behavior: "smooth",
      });
    }

    /* The state attribute drives the arrows in CSS; the 2px margin absorbs a scrollLeft a fraction short of the end. */
    onScroll() {
      var max = this.track.scrollWidth - this.track.clientWidth;
      var state = "middle";

      if (max <= 2) {
        state = "disabled";
      } else if (this.track.scrollLeft <= 2) {
        state = "start";
      } else if (this.track.scrollLeft >= max - 2) {
        state = "end";
      }

      this.setAttribute("state", state);
    }

    onDown(event) {
      // Touch and pen scroll natively; only a mouse drags.
      if (event.pointerType !== "mouse" || event.button !== 0) {
        return;
      }

      this.pressed = true;
      this.dragging = false;
      this.startX = event.clientX;
      this.startScroll = this.track.scrollLeft;
    }

    onMove(event) {
      if (!this.pressed) {
        return;
      }

      // A release the track never saw, e.g. after a Mac ctrl-click menu.
      if (!(event.buttons & 1)) {
        this.onUp(event);
        return;
      }

      var delta = event.clientX - this.startX;

      /* 4px before it counts as a drag, so a wobbly click stays a click. Capture only now: capturing on press retargets the click to the track. */
      if (!this.dragging && Math.abs(delta) > 4) {
        this.dragging = true;
        this.classList.add("drag-scroller--dragging");
        this.track.setPointerCapture(event.pointerId);
      }

      if (this.dragging) {
        this.track.scrollLeft = this.startScroll - delta;
      }
    }

    onUp(event) {
      if (!this.pressed) {
        return;
      }

      this.pressed = false;

      if (!this.dragging) {
        return;
      }

      this.dragging = false;
      this.track.releasePointerCapture(event.pointerId);

      /* Released next frame: click fires after pointerup, so dropping the class now would let the drag navigate. */
      requestAnimationFrame(() => {
        this.classList.remove("drag-scroller--dragging");
      });
    }
  }
);
}
